import { useCallback } from "react";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import type { SerializableComponentBlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { getBlockName } from "@circle-react-shared/BuilderUI/Helpers/getBlockName";
import { Preview } from "./Preview";

export interface ComponentPreviewProps {
  block: SerializableComponentBlockExport;
  isElementType?: boolean;
  isOverlay?: boolean;
}

export const ComponentPreview = ({
  block,
  isOverlay = false,
  isElementType = false,
}: ComponentPreviewProps) => {
  const addBlocksToRoot = useBuilderStore(state => state.addBlocksToRoot);
  const defaultData = block.defaultData;
  const name = getBlockName(block.meta);

  const handleAddBlock = useCallback(() => {
    if (isOverlay) return;
    addBlocksToRoot(defaultData, undefined, true);
  }, [addBlocksToRoot, defaultData, isOverlay]);

  return (
    <Preview
      isElementType={isElementType}
      name={name}
      block={block}
      onAddBlock={handleAddBlock}
      isOverlay={isOverlay}
    />
  );
};
